import React, { Component } from "react";
import { ReactTableServerSide } from "../../ReactTableServerSide";
import Popup from "reactjs-popup";
import auth from "../../../Auth";
import { adminView, adminExecuteUpdate, adminViewCols } from "../../../apis";
import { Typography, Grid } from "@material-ui/core";

import {
  updateTable,
  toggleRow,
  isSelected,
} from "../../components/TableMethods.js";

import CustomizeColumns from "./CustomizeColumns";

import "../../custom_material_ui_like.css";

const { config } = window;

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
} from "@mui/material";

//this view is only for the admin
//check keycloak group if the user is indeed an admin

/**
 * Component for modifying Projects-, Datasets- or Files data.
 * @component
 * @category admin
 * @subcategory admin-view
 */

// TODO
// the admin dataset view should also show the
// associated group ids

// FIXME
// Shared with colum are returned as empty

export class AdminDataView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // get last part of this.props.location
      dataType: this.props.location.pathname.split("/")[2],
      headers: [],
      modifiableFields: [],
      fieldSelected: "",
      newValue: "",
      pagination: {
        loadData: true,
        page: 0,
        pages: 0,
        pageSize: 100,
        totalItems: 0,
        fields: [],
        filtered: [],
        sorted: [],
      },
      items: [],
      selected: [],
      selectedFields: {},
      selectAll: 0,
      popupErrors: "",
      csvData: [],
      csvFileName: "",
      redirectExperimentInformation: "",
      columnsShown: [],
      open: false,
      setOpen: false,
      defaultColumnsBool: true,
    };

    //needed for CustomizeColumns
    this.updateColumns = this.updateColumns.bind(this);
    this.getDataColumnTable = this.getDataColumnTable.bind(this);
  }

  async getViewCols(api) {
    let jsonData = {};

    const query = {
      api,
    };

    // ! FIXME 
    // Why is this a post request?

    try {
      const response = await adminViewCols(
        auth.getToken(),
        config.api_endpoint,
        `${api}`,
        query
      );
      jsonData = await response.json();
      return jsonData[0].headers;
    } catch (error) {
    }
  }

  async componentDidMount() {
    if (auth.tokenExpired()) {
      this.setState({
        popupErrors: "Session expired. Please login again",
      });
    }

    const tableHeaders = await this.getViewCols(this.state.dataType);

    if (this.state.dataType === "datasets") {
      this.setState({
        headers: tableHeaders,
        modifiableFields: tableHeaders.slice(2),
        pageHeader: "Admin view for Datasets",
        subTitle: "Select the datasets/field to be modified",
      });
    }

    if (this.state.dataType === "files") {
      this.setState({
        headers: tableHeaders,
        modifiableFields: tableHeaders.slice(1),
        pageHeader: "Admin view for Files",
        subTitle: "Select the files/field to be modified",
      });
    }

    if (this.state.dataType === "projects") {
      this.setState({
        headers: tableHeaders,
        modifiableFields: tableHeaders.slice(2),
        pageHeader: "Admin view for Projects",
        subTitle: "Select the projects/field to be modified",
      });
    }
  }

  getDataColumnTable() {
    const toggleSelectAll = (selectAll, rows) => {
      const newSelected = [];
      //Update all checkboxes as checked
      if (selectAll === 0) {
        for (const row of rows) {
          newSelected.push(row);
        }
      }
      return newSelected;
    };

    const columnCheckbox = {
      id: "checkbox",
      Header: (x) => (
        <span>
          Select{" "}
          <input
            type="checkbox"
            className="checkbox"
            checked={this.state.selectAll === 1}
            ref={(input) => {
              if (input && this.state.selectAll === 2) {
                if (this.state.selected.length === 0) {
                  input.checked = false;
                } else {
                  input.indeterminate = true;
                }
              }
            }}
            onChange={() =>
              this.setState({
                selected: toggleSelectAll(this.state.selectAll, [
                  ...this.state.items,
                ]),
                selectAll: this.state.selectAll === 0 ? 1 : 0,
              })
            }
          />
        </span>
      ),
      Cell: ({ original }) => {
        return (
          <input
            type="checkbox"
            className="checkbox"
            checked={isSelected(original.id, this.state.selected)}
            onChange={() =>
              this.setState({
                selected: toggleRow(original, this.state.selected),
                selectAll: 2,
              })
            }
          />
        );
      },
      sortable: false,
      filterable: false,
      width: 80,
    };
    const columns = [columnCheckbox];

    if (this.state.dataType === "datasets") {
      const columnDataPolicy = {
        id: "dataPolicy",

        Cell: ({ original }) => {
          if (original.dataPolicy !== "") {
            const val = original.policy_presigned_url;
            return <a href={val}> {val} </a>;
          } else {
            return <div />;
          }
        },
        Header: "Data Policy",
        sortable: false,
        filterable: false,
        width: 120,
      };
      columns.push(columnDataPolicy);

      const columnClinicalData = {
        id: "clinicalData",

        Cell: ({ original }) => {
          if (original.dataPolicy !== "") {
            const val = original.clinical_presigned_url;
            return <a href={val}> {val} </a>;
          } else {
            return <div />;
          }
        },
        Header: "clinicalData",
        sortable: false,
        filterable: false,
        width: 120,
      };
      columns.push(columnClinicalData);
    }

    return updateTable(
      columns,
      this.state.columnsShown,
      this.state.headers,
      this.state.items,
      this.state.defaultColumnsBool
    );
  }

  closeModal = () => {
    if (this.state.popupErrors === "Session expired. Please login again") {
      auth.user.keycloak.logout();
    }
    this.setState({ popupErrors: "" });
  };

  // Dummy method because ReactTableServerSide needs it
  onRowClick = (state, rowInfo, column, instance) => ({
    onClick: (e) => {
      //
    },
  });

  getData = async (data_query, filtered, sorted) => {
    /* Call POST Data*/

    // would be better to get this from the state
    // but the getData seemed to be called before
    // the state was set
    const dataType = this.props.location.pathname.split("/")[2];

    adminView(
      auth.getToken(),
      config.api_endpoint,
      dataType,
      JSON.stringify(data_query)
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          items: data.items,
          pagination: {
            page: data._meta.page,
            pages: data._meta.total_pages,
            pageSize: data._meta.page_size,
            totalItems: data._meta.total_items,
            // fields: fields,
            filtered,
            sorted,
            loadData: false,
          },
        });
      });
  };

  /*Method to call API Endpoint to get React Table Data*/
  loadTableData = (state) => {
    /*Call API Endpoint*/
    const data_query = {
      page: state.page + 1,
      pageSize: state.pageSize,
      // fields: fields,
    };
    /*Check filtered Criteria*/
    if (state.filtered) {
      data_query.filtered = state.filtered.map((item) => ({
        id: item.id,
        value: item.value,
      }));
    }
    /*Check sorted Criteria*/
    if (state.sorted) {
      data_query.sorted = state.sorted;
    }

    /* Call POST Data*/
    this.getData(data_query, state.filtered, state.sorted);
  };

  updateColumns(columns) {
    //needed for CustomizeColumns
    this.setState({ columnsShown: columns });
    this.setState({ defaultColumnsBool: false });
  }

  handleUpdate = async () => {
    const { selected, fieldSelected, newValue } = this.state;

    if (selected === [] && fieldSelected === "" && newValue === "") {
      return;
    }

    if (selected === "" || fieldSelected === "" || newValue === "") {
      this.setState({ popupErrors: "Please fill all fields" });
    }

    const selectedRows = selected.map((item) => item.id);

    const response = await adminExecuteUpdate(
      auth.getToken(),
      config.api_endpoint,
      this.state.dataType,
      JSON.stringify({
        dbRowIds: selectedRows,
        field: fieldSelected,
        value: newValue,
      })
    );
    const error_msg = await response.text();
    if (response.status === 200) {
      const { page, pageSize, filtered, sorted } = this.state.pagination;

      const data_query = {
        page: page + 1,
        pageSize,
        filtered,
        sorted,
      };
      this.getData(data_query, filtered, sorted);
    } else {
      this.setState({ popupErrors: error_msg });
    }
  };

  // ! FIXME
  // after pressing update the pagination (top right)
  // does not behave as expected
  // starts with 1-10 of 2 records
  // after pressing update the pagination starts with 11-20 of 2 records
  // with every update the pagination increases by 10

  // this happens also when doing dataset sharing

  // note: the changes do not persist after reloading the page
  // it is again 1-10 of 2 records

  render() {
    /*Show popup in case an error with the login occurs*/
    if (this.state.popupErrors) {
      return (
        <Popup open={true} closeOnDocumentClick onClose={this.closeModal}>
          <div>
            <button className="close" onClick={this.closeModal}>
              {" "}
              &times;{" "}
            </button>
            <div className="page-header">
              {" "}
              <h1>Logging error</h1>{" "}
            </div>
            <div className="alert alert-warning">{this.state.popupErrors} </div>
          </div>
        </Popup>
      );
    }

    const columnsDataTable = this.getDataColumnTable();

    return (
      <>
        {auth.getUserGroups().includes("admin") ? (
          <Grid container justify="space-around" spacing={2}>
            <Grid item xs={12}>
              <Typography variant={"h5"} align={"center"}>
                {" "}
                {this.state.pageHeader}{" "}
              </Typography>
            </Grid>

            {/* create a selection box */}
            <Grid item xs={12}>
              <Typography variant={"h5"} align={"left"} padding={4}>
                {" "}
                {this.state.subTitle}{" "}
              </Typography>

              {/* add space before next component */}
              <div style={{ height: "20px" }} />

              <FormControl sx={{ m: 1, minWidth: 420 }}>
                <InputLabel id="field-select-label">Field</InputLabel>
                <Select
                  id="field-select"
                  label="Column"
                  value={this.state.fieldSelected}
                  onChange={(e) =>
                    this.setState({ fieldSelected: e.target.value })
                  }
                >
                  {this.state.modifiableFields.map((option) => (
                    <MenuItem value={option.key}>{option.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* mui input field */}
              <TextField
                sx={{ m: 1, minWidth: 420 }}
                id="standard-basic"
                label="Value"
                value={this.state.newValue}
                onChange={(e) => this.setState({ newValue: e.target.value })}
              />
              {/* Mui Submit button */}
              <Button
                sx={{ m: 1 }}
                variant="contained"
                color="primary"
                onClick={() => {
                  this.handleUpdate();
                }}
              >
                Update
              </Button>
            </Grid>
            <Grid item xs={12}>
              <CustomizeColumns
                headers={this.state.headers}
                updateColumns={this.updateColumns}
              />
              <Grid item xs={12}>
                <ReactTableServerSide
                  headers={this.state.headers}
                  columns={columnsDataTable[0]}
                  data={columnsDataTable[1]}
                  pagination={this.state.pagination}
                  onRowClick={this.onRowClick}
                  loadTableData={this.loadTableData}
                  loading={this.state.pagination.loadData}
                  fieldsDelay={[]}
                />
              </Grid>
            </Grid>
          </Grid>
        ) : null}
      </>
    );
  }
}
